<style lang="scss" scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $z-navigation-bar;

  width: 100%;
}

.declaration {
  padding-top: 0.2rem;

  font-size: 0.28rem;
  color: #262626;

  .intro {
    padding: 0.32rem;

    background: #fff;
    line-height: 1.6;
    color: #595959;
  }

  .info-section {
    padding: 0.16rem 0.4rem;

    background: #fff;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;

    .info {
      margin: 0.16rem 0;

      font-size: 0.28rem;
      font-weight: 400;
      line-height: 0.4rem;
      color: #262626;
    }
  }

  .scope-section {
    padding: 0.32rem 0.4rem 0.36rem;

    background: #fff;
  }

  .scope-title {
    margin-bottom: 0.24rem;

    font-size: 0.36rem;
    font-weight: 700;
    line-height: 0.5rem;
  }

  .scope-item {
    position: relative;

    padding-left: 0.36rem;

    font-size: 0.28rem;
    font-weight: 400;
    line-height: 0.44rem;

    &:not(:last-child) {
      margin-bottom: 0.16rem;
    }

    &:before {
      position: absolute;
      top: 0.16rem;
      left: 0.04rem;

      width: 0.12rem;
      height: 0.12rem;

      background: #595959;
      border-radius: 50%;

      content: '';
    }
  }
}
</style>

<template>
  <page
    :custom-style="{
      display: 'flex',
      'flex-direction': 'column',
      'background-color': '#fff',
      height: '100vh',
      'padding-top': pagePaddingTop
    }"
  >
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      :safe-top-distance="statusBarHeight"
      class="nav-bar"
      left-arrow
      title="个人店铺声明"
      @click-left="goBack"
    />
    <scroll-view v-show="verifySuccess" :background="'#F5F5F5'">
      <div class="declaration">
        <p class="intro">
          根据《中华人民共和国电子商务法》相关规定，个人销售自产农副产品、家庭手工业产品，个人利用自己的技能从事依法无须取得许可的便民劳务活动和零星小额交易活动，以及依照法律、行政法规不需要进行登记。
        </p>
        <div class="info-section">
          <p class="info">联系方式：{{ personalDeclaration.contactPhone }}</p>
          <p class="info">
            经营地址：{{ personalDeclaration.businessAddress }}
          </p>
        </div>
        <div class="scope-section">
          <p class="scope-title">经营主体自我声明</p>
          <p
            v-for="(scope, index) in personalDeclaration.businessScope"
            :key="index"
            class="scope-item"
          >
            {{ scope }}
          </p>
        </div>
      </div>
    </scroll-view>
    <Verify
      :env="PASSPORT_GATEWAY_ENV"
      :device-id="deviceId"
      :app-key="appKey"
      :start="showVerify"
      :scene="'pop/getpopqualificationpic'"
      @callback-verified="callbackVerified"
      @callback-tracer="callbackTracer"
    />
  </page>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Verify } from '@mc/passport-h5-verify'
import { deviceId, miniProgramEnv, appKey } from '@/defines/environment'
import { PASSPORT_GATEWAY_ENV } from '@/defines/environment/config'
import ScrollView from '@/common/widgets/scroll_view'
import Url from '@mc/mc-utils/js/url/url'

export default {
  name: 'PersonShopInfo',
  components: {
    Verify,
    ScrollView
  },
  beforeRouteEnter(to, from, next) {
    const url = new Url(window.location.href)
    const query = url.parseQuerystring()
    const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
    const id = query.pop_id || hashQuery.pop_id || ''
    const showBiz = Number(query.show_biz || hashQuery.show_biz || 2)

    next(vm => {
      if (!vm.$store.state.pop.shop.id && id) {
        vm.$store.commit('pop/updateShopId', id)
      }
      vm.showBiz = showBiz
      vm.showVerify = true
      vm.verifySuccess = false
    })
  },
  data() {
    return {
      browerInfo: window.matrix,
      showVerify: true,
      verifySuccess: false,
      showBiz: 2,
      deviceId,
      appKey,
      PASSPORT_GATEWAY_ENV
    }
  },
  computed: {
    ...mapState('pop', ['qualification']),
    personalDeclaration() {
      return this.qualification.personalDeclaration
    },
    pagePaddingTop() {
      return miniProgramEnv.isMiniProgram
        ? '0px'
        : 44 + this.statusBarHeight + 'px'
    }
  },
  methods: {
    ...mapActions('pop', ['getPopPersonalDeclaration']),
    goBack() {
      this.$back()
    },
    callbackVerified(data) {
      if (data.code !== 0) return
      this.getPopPersonalDeclaration({
        verifyId: data.verifyId,
        showBiz: this.showBiz
      })
        .then(() => {
          this.showVerify = false
          this.verifySuccess = true
        })
        .catch(e => {
          this.$catch(e)
        })
    },
    callbackTracer(param) {
      if (param === 'close') {
        this.showVerify = false
      }
    }
  }
}
</script>
